import { createReducer } from '@reduxjs/toolkit';
import * as actions from 'GlobalModule/actionCreators';
import * as thunkActions from 'thunk';

export type GlobalStateType = {
  isDevMode: boolean;
  openRoutes: Record<string, boolean>;
  requestStatusesAndErrors: {
    [x: string]: {
      isRequesting: boolean;
      error: Record<string, any>;
    };
  };
  // Global UI flags
  isUnauthorizedModalOpen: boolean;
};

const INITIAL_STATE: GlobalStateType = {
  isDevMode: false,
  openRoutes: {},
  requestStatusesAndErrors: {
    [thunkActions.createTeam.typePrefix]: {
      isRequesting: false,
      error: {},
    },
  },
  isUnauthorizedModalOpen: false,
};

export default createReducer(INITIAL_STATE, (builder) => {
  builder.addCase(actions.toggleDevMode, (state, _) => {
    state.isDevMode = !state.isDevMode;
  });
  builder.addCase(actions.updateOpenRoutes, (state, { payload }) => {
    state.openRoutes = {
      ...state.openRoutes,
      ...payload,
    };
  });
  builder.addCase(actions.openUnauthorizedModal, (state) => {
    state.isUnauthorizedModalOpen = true;
  });
  builder.addCase(actions.closeUnauthorizedModal, (state) => {
    state.isUnauthorizedModalOpen = false;
  });
});
